export default __webpack_public_path__ + "static/media/blackDot.0cace755.svg";